import React, { memo, useCallback, useMemo } from "react";
import { Box } from "../Box";
import { MainText } from "../MainText";
import { CommentaryType } from "./Commentary";
import { useDispatch, useSelector } from "react-redux";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import i18n from "@microdoing/shared/i18n";
import { PressableOpacity } from "../PressableOpacity";
import moment from "moment";
import { getUserTimezone } from "@microdoing/shared/services/user/selectors";

export interface ICommentaryHeaderProps {
  commentary: CommentaryType;
  handleResponse: () => void; // ? Ici c'est la fonction pour Edit son message si besoin
}

const CommentaryHeader = ({ commentary }: ICommentaryHeaderProps) => {
  const timezone = useSelector(getUserTimezone);

  const dispatch = useDispatch();

  const calculCommentDays = useMemo(
    () => moment().diff(moment(commentary.createdAt).tz(timezone), "days"),
    [commentary.createdAt, timezone],
  );

  const handleSeeUser = useCallback(() => {
    dispatch(requestExternalUser({ userId: commentary?.user?._id }));
  }, [commentary?.user?._id]);

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="space-between">
      <Box flexDirection="row" alignItems="center">
        <PressableOpacity onPress={handleSeeUser}>
          <MainText color="neutral.900" variant="l4-bold">
            {commentary?.user?.firstName}
          </MainText>
        </PressableOpacity>
        {commentary?.commentId ? (
          <MainText marginLeft="xxs" variant="l3-medium" color="neutral.600">
            {calculCommentDays > 1
              ? i18n.t("commentary-action-date_plural", {
                  numberOfTime: calculCommentDays,
                })
              : i18n.t("commentary-action-date", {
                  numberOfTime: calculCommentDays,
                })}
          </MainText>
        ) : (
          <MainText marginLeft="xxs" variant="l3-medium" color="neutral.600">
            {calculCommentDays > 1
              ? i18n.t("commentary-realised-the-action_plural", {
                  numberOfTime: calculCommentDays,
                })
              : i18n.t("commentary-realised-the-action", {
                  numberOfTime: calculCommentDays,
                })}
          </MainText>
        )}
      </Box>
    </Box>
  );
};

export default memo(CommentaryHeader);
